import { render, staticRenderFns } from "./MatchHeroBanner.vue?vue&type=template&id=1a88dbc1&scoped=true"
import script from "./MatchHeroBanner.vue?vue&type=script&lang=js"
export * from "./MatchHeroBanner.vue?vue&type=script&lang=js"
import style0 from "./MatchHeroBanner.vue?vue&type=style&index=0&id=1a88dbc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a88dbc1",
  null
  
)

export default component.exports